<script lang="ts">
  import AssigneeTasks from "./AssigneeTasks.svelte"
  import { appStore } from "$app/store.svelte"

  const allAssignees = appStore.assignees

  let assigneeList = [
    ...allAssignees.filter((a) => {
      return (
        a.type === "Department" &&
        appStore.tasks.filter(
          (t) => t.assignee_id === a.id && t.assignee_type === "Department"
        ).length > 0
      )
    }),
    ...allAssignees.filter((a) => {
      return (
        a.type === "User" &&
        appStore.tasks.filter(
          (t) => t.assignee_id === a.id && t.assignee_type === "User"
        ).length > 0
      )
    }),
    ...allAssignees.filter(
      (a) =>
        a.type === "Department" &&
        appStore.tasks.filter(
          (t) => t.assignee_id === a.id && t.assignee_type === "Department"
        ).length === 0
    ),
    ...allAssignees.filter(
      (a) =>
        a.type === "User" &&
        appStore.tasks.filter(
          (t) => t.assignee_id === a.id && t.assignee_type === "User"
        ).length === 0
    )
  ]
</script>

{#each assigneeList as assignee, idx (idx)}
  <AssigneeTasks {assignee} />
{/each}
